import {PlatformDTO} from "./platformDTO.interface";
import {BaseDTO} from "./_baseDTO.interface";

export interface CommDTO extends BaseDTO {
  platformId: number;
  commsTitle: string;
  commsTemplate: string;
  platform: PlatformDTO;
}
